<div class="header-bar">
    <!--a *ngIf="backLink" [routerLink]="backLink" class="back-link">
        <fa-icon [icon]="['far', 'chevron-left']"></fa-icon>
        <span class="sr-only">Back</span>
    </a-->
    <h2>{{title}}</h2>
</div>